import React from 'react'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'
import img from '../Assets/imgnews.png'
function News() {
  const posts = [
    {
      id: '01',
      date: 'April 24, 2024',
      title: 'Top 10 Afterparty Golden Rules',
      excerpt:
        'Private theatre celebrations are redefining milestone moments. From birthdays to date nights, the experience feels more personal when the room, screen, and surprise are all built around your people.',
      image: img,
      tag: 'Celebration Guide',
    },
    {
      id: '02',
      date: 'April 24, 2024',
      title: 'How To Make A Private Screening Feel Special',
      excerpt:
        'The best private screenings balance comfort, styling, and timing. A thoughtful entry setup, meaningful on-screen content, and a small personalized touch can turn a booking into a memory.',
      image: img,
      tag: 'Event Planning',
    },
  ]

  return (
    <>
        <Navbar/>
        <div className='news-banner'>
        <p>Blog</p>
        <br/>
        <h3>Our News & Events</h3>

        </div>
        <section className='news-revamp'>
          <div className='news-revamp__intro'>
            <p className='news-revamp__eyebrow'>Editorial Picks</p>
            <h2>Ideas, inspiration, and celebration notes from our world.</h2>
            <p className='news-revamp__text'>
              Explore quick reads around private screenings, surprise planning,
              and ways to make every event feel more cinematic.
            </p>
          </div>

          <div className='news-revamp__grid'>
            {posts.map((post, index) => (
              <article
                className={`news-card ${index === 0 ? 'news-card--featured' : ''}`}
                key={post.id}
              >
                <div className='news-card__media'>
                  <img src={post.image} alt={post.title} />
                  <span className='news-card__tag'>{post.tag}</span>
                </div>

                <div className='news-card__body'>
                  <div className='news-card__meta'>
                    <span className='news-card__count'>{post.id}</span>
                    <div>
                      <p className='news-card__date'>{post.date}</p>
                      <h3>{post.title}</h3>
                    </div>
                  </div>

                  <p className='news-card__excerpt'>{post.excerpt}</p>
                  <button className='news-card__button'>Read More</button>
                </div>
              </article>
            ))}
          </div>
        </section>
        <Footer/>

    </>
  )
}

export default News
